import { Component, Input, OnInit } from '@angular/core';
import { HotkeyItem } from '../hotkeys.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'hotkey-row',
  templateUrl: './hotkey-row.component.html',
  styleUrls: ['./hotkey-row.component.scss'],
})
export class HotkeyRowComponent implements OnInit {

  public isMac: boolean = this.deviceInformation.os == "Mac"

  @Input() public row: HotkeyItem
  @Input() public withBorder: boolean

  constructor(
    private deviceInformation: DeviceDetectorService,
  ) { }

  ngOnInit() {}

}
